import classNames from 'classnames'
import { omit } from 'lodash-es'

import dictStore from '@/store/global/dictStore'
import { isNotEmptyArray } from '@/utils'

import { renderFormItem } from '../../utils'

const getLabels = ({
  options,
  value,
  extra,
  fieldNames
}: {
  options: any[]
  value: any
  extra: any
  fieldNames: any
}) => {
  const { label = 'name', value: valueName = 'value' } = fieldNames || {}
  const getLabel = (item: any) => {
    return item?.[label] || item?.name || item?.label
  }
  if (extra) {
    if (isNotEmptyArray(extra)) {
      return extra?.map((item: any) => getLabel(item))?.join(',')
    }
    return getLabel(extra)
  }
  if (isNotEmptyArray(value)) {
    return options
      ?.filter((item: any) => value?.includes(item[valueName]))
      ?.map((item: any) => getLabel(item))
      ?.join(',')
  }
  return getLabel(options?.find((item: any) => value === item[valueName]))
}

const getDictList = (data: any) => {
  const { dictionary, dataList, options } = data || {}
  const dictList = dictStore?.dictMap?.[dictionary] || []
  return [dataList, options, dictList]?.find((item: any) => item?.length > 0) || []
}

export const publicEvents = {
  /**
   * 通用onChange时间
   * @param e 控件值
   * this.extra 额外参数
   */
  onChange: function (e?: any, type?: string) {
    const trigger = renderFormItem(type || this.type)?.trigger || 'onChange'
    const beforeChange = this.onBeforeChange || this.elementProps?.onBeforeChange
    beforeChange?.(e, this.extra)
    typeof this[trigger] === 'function' && this[trigger]?.(e, this.extra)
    if (this.onAfterChange || this.elementProps?.onAfterChange) {
      this.globalProps?.onAfterChangeExec?.(
        this.onAfterChange || this.elementProps?.onAfterChange,
        this.globalProps?.state,
        this.globalProps?.option,
        e
      )
    }

    if (
      this?.formProps?.type?.toLowerCase()?.includes('select') &&
      this?.formProps?.name?.[0] === 'extended_param'
    ) {
      const cloneName = this?.formProps?.name?.slice(0)
      cloneName[cloneName.length - 1] = `${cloneName[cloneName.length - 1]}_name`
      const options = getDictList(this)

      this?.form?.setFieldValue(
        cloneName,
        getLabels({
          options,
          fieldNames: this?.fieldNames,
          value: e,
          extra: this.extra
        })
      )
    }
  }
}

/**
 * 所有控件公共属性（参数组装）
 * @param props 所有参数
 * @param className h-*
 * @returns elementProps
 */
export const publicProps = (props: any, className: string) => {
  const _props = Object.entries(props)
    .filter(([key, value]: [string, unknown]) => value !== undefined)
    .reduce((obj: any, [key, value]: [string, unknown]) => {
      return {
        ...obj,
        [key]: value
      }
    }, {})
  const elementProps = {
    ...omit(_props, ['elementProps', 'formItemProps', 'globalProps']),
    ...props.elementProps,
    //  className取值
    className: classNames(
      { [`h-${className}`]: !!className },
      props.className,
      props.elementProps?.className
    ),
    placeholder: props.disabled ? '' : props.placeholder,
    // 公共onChange
    onChange: (e: any) => publicEvents.onChange.call(props, e)
  }
  return elementProps
}
